import React from "react";

export default function IconPresential(props) {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_8234_73505)">
        <path
          d="M10.7123 10.8646L7 14.577L3.28767 10.8646C2.55345 10.1304 2.05344 9.19494 1.85087 8.17654C1.64831 7.15814 1.75228 6.10255 2.14964 5.14324C2.547 4.18393 3.21991 3.364 4.08327 2.78712C4.94662 2.21025 5.96165 1.90234 7 1.90234C8.03835 1.90234 9.05338 2.21025 9.91674 2.78712C10.7801 3.364 11.453 4.18393 11.8504 5.14324C12.2477 6.10255 12.3517 7.15814 12.1491 8.17654C11.9466 9.19494 11.4466 10.1304 10.7123 10.8646ZM7 9.48563C7.61884 9.48563 8.21233 9.2398 8.64992 8.80221C9.0875 8.36463 9.33334 7.77114 9.33334 7.1523C9.33334 6.53346 9.0875 5.93997 8.64992 5.50238C8.21233 5.0648 7.61884 4.81896 7 4.81896C6.38116 4.81896 5.78767 5.0648 5.35009 5.50238C4.9125 5.93997 4.66667 6.53346 4.66667 7.1523C4.66667 7.77114 4.9125 8.36463 5.35009 8.80221C5.78767 9.2398 6.38116 9.48563 7 9.48563ZM7 8.31896C6.69058 8.31896 6.39384 8.19605 6.17505 7.97726C5.95625 7.75846 5.83334 7.46172 5.83334 7.1523C5.83334 6.84288 5.95625 6.54613 6.17505 6.32734C6.39384 6.10855 6.69058 5.98563 7 5.98563C7.30942 5.98563 7.60617 6.10855 7.82496 6.32734C8.04375 6.54613 8.16667 6.84288 8.16667 7.1523C8.16667 7.46172 8.04375 7.75846 7.82496 7.97726C7.60617 8.19605 7.30942 8.31896 7 8.31896Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8234_73505">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.738281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
